import { Text } from "../../../types";

const textLables: {
  [key: number]: string[];
} = {
  2: ["Jahr", "Beschreibung"],
  3: ["Beschreibung"],
  5: ["Bildname", "Fortschritt"],
};

const DashboardTextSection = ({
  data,
  onUpdateText,
  pageId,
}: {
  data: Text[];
  onUpdateText: (textId: number, content: string) => void;
  pageId: number;
}) => {
  return (
    <div style={{ border: "1px solid white" }}>
      {data.map((text, textPosition) => (
        <div key={text.id}>
          <h3>{textLables[pageId][textPosition] || `Text ${textPosition}`}</h3>
          <textarea
            value={text.content}
            onChange={(e) => onUpdateText(text.id, e.target.value)}
          />
        </div>
      ))}
    </div>
  );
};

export default DashboardTextSection;
